"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var utils_1 = require("../../utils");

var Star_1 = tslib_1.__importDefault(require("./Star"));

var styles = tslib_1.__importStar(require("./RatingStars.style"));

function RatingStars(_ref) {
  var className = _ref.className,
      ratingValue = _ref.ratingValue;
  var ratings = Array(5).fill(0);
  return jsx_runtime_1.jsx("div", Object.assign({
    className: className,
    css: styles.container
  }, {
    children: jsx_runtime_1.jsx("div", Object.assign({
      css: styles.contentContainer
    }, {
      children: ratings.map(function (_rating, index) {
        return jsx_runtime_1.jsx(Star_1.default, {
          filled: utils_1.getRatingType(ratingValue, index)
        }, react_id_generator_1.default());
      })
    }), void 0)
  }), void 0);
}

exports.default = react_1.memo(RatingStars);